import {
  excpectedEventLogoHeight,
  excpectedEventLogoWidth
} from '@constants/file';
import { AddToMode } from '@features/forms/types';

export const COVER_IMAGE_HINT =
  'Shown at the top of your public form. Choose a cover image or upload your own.';

export const COVER_IMAGE_REQUIREMENTS = 'Supported file: PNG/JPG (max. 2MB)';

export const COVER_IMAGE_UPLOAD_SUBTEXT = `Supported file: PNG or JPG (max. 2MB) ; Recommended dimensions are ${excpectedEventLogoWidth} x ${excpectedEventLogoHeight} pixels`;

export const COVER_IMAGE_MODAL_TITLE = 'Choose cover image';
export const COVER_IMAGE_GALLERY_TITLE = 'Choose image';

export const FORM_PRESET_COVER_IMAGES = [
  {
    id: 'cover-1',
    url: 'https://cofee-images1.s3.ap-southeast-1.amazonaws.com/cover_image_1.png',
    uploadPath: '/form-cover-images/cover_image_1.png',
    alt: 'Admission form cover'
  },
  {
    id: 'cover-2',
    url: 'https://cofee-images1.s3.ap-southeast-1.amazonaws.com/cover_image_2.png',
    uploadPath: '/form-cover-images/cover_image_2.png',
    alt: 'Annual fees cover'
  },
  {
    id: 'cover-3',
    url: 'https://cofee-images1.s3.ap-southeast-1.amazonaws.com/cover_image_3.png',
    uploadPath: '/form-cover-images/cover_image_3.png',
    alt: 'School supplies cover'
  },
  {
    id: 'cover-4',
    url: 'https://cofee-images1.s3.ap-southeast-1.amazonaws.com/cover_image_4.png',
    uploadPath: '/form-cover-images/cover_image_4.png',
    alt: 'Exam fee cover'
  }
] as const;

export const COVER_IMAGE_MAX_SIZE = 2 * 1000000;

export const DESCRIPTION_MAX_LENGTH = 10000;

export const GROUP_FEE_MIN = 2;
export const GROUP_FEE_MAX = 60000;
export const MEMBER_LIST_FEE_MIN = 2;
export const MEMBER_LIST_FEE_MAX = 50000;

export const ADD_TO_MODE_OPTIONS: {
  mode: AddToMode;
  title: string;
  description: string;
}[] = [
  {
    mode: 'group',
    title: 'A specific group',
    description:
      'Student is added to the group on payment and fee configuration will apply to the student.'
  },
  {
    mode: 'member_list',
    title: 'Member list',
    description:
      'Set an admission fee. Student is added to your member list. You assign them to a group later.'
  }
];

export const START_COLLECTION_OPTIONS = [
  {
    key: 'same_month',
    value: 'Same month as registration'
  },
  {
    key: 'next_month',
    value: 'From next month'
  }
];

export const DEFAULT_START_COLLECTION_FROM = 'next_month';

export const MAX_REGISTRATIONS_HINT =
  'Form stops accepting registrations when the limit is reached.';

export const MAX_REGISTRATIONS_PAID_COUNT_ERROR =
  'Maximum registration count cannot be less than current paid registrations.';

export const APPLY_DISCOUNT_HINT =
  'Applied to the total for students enrolling via this form.';

export const MIN_PENDING_REGISTRATION_AMOUNT = 100;

export const DISCOUNT_PENDING_AMOUNT_ERROR =
  'Please ensure the registration amount remains ₹100 or more.';
